import type { CreateLocationRequest, LocationDetail } from '@/definitions/location'
import api from '@/services/api'

export const CreateLocation = async (
  orgId: string,
  data: CreateLocationRequest
): Promise<LocationDetail> => {
  const response = await api.post<LocationDetail>(`/api/v1/locations/${orgId}`, data)
  return response.data
}

/**
 * Every location the organization has, each with its address, phone, and time zone.
 *
 * One request however many locations the organization has — the response carries
 * everything a reader displays, so nothing further is read per location.
 */
export const FetchLocations = async (orgId: string): Promise<LocationDetail[]> => {
  const response = await api.get<LocationDetail[]>(`/api/v1/locations/${orgId}`)
  return response.data
}
